import React from 'react';
import logo from './logo.svg';
import SwaggerUI from "swagger-ui-react"

import Header from "./components/Header"
import "swagger-ui-react/swagger-ui.css"
import './App.css';
import { check } from 'prettier';


async function checkApiAuth(apiKey: string): Promise<void> { 
  const results = await fetch(`${process.env.REACT_APP_BACKEND_URL}/`,
    {
      headers: {Authorization: `ApiKey ${apiKey}`}
    });

  if(results.status === 401) {
    throw new Error()
  }

}
async function loadOpenApiSpec(apiKey?: string): Promise<string> {
  const results = await fetch(`${process.env.REACT_APP_BACKEND_URL}/v1/open-api/api.yml `,
    {
      headers: apiKey ? {Authorization: `ApiKey ${apiKey}`} : {}
    });

    if(results.status === 200) {
      let spec = await results.text()

      spec = spec.replace("- url: https://api.truepill.com/",  `- url: ${process.env.REACT_APP_BACKEND_URL!}`) 
      spec = spec.replace("- url: https://api.falsepill.com/", "")

      console.log(spec)
      return spec
    } else {
      throw new Error()
    }
  }

export default function App() {
  const [apiKey, setApiKey] = React.useState("")
  const [openApiSpec, setOpenApiSpec] = React.useState("")
  const [apiKeyIsValid, setApiKeyIsValid] = React.useState(false)

  React.useEffect(() => {
    loadOpenApiSpec().then((spec) => {
      setOpenApiSpec(spec)
    })
   }, []);

  return (
    <div className="App">
       <Header onApiKeyChange={
        async (apiKey) => {
          if(apiKey) {
            try {
              await checkApiAuth(apiKey)
              let openApiSpec = await loadOpenApiSpec(apiKey)

              setApiKey(apiKey);
              setApiKeyIsValid(true);

              swaggerUiRef.preauthorizeApiKey("api_key", `ApiKey ${apiKey}`);
              
              setOpenApiSpec(openApiSpec)
            } catch (e) {
              alert("Sorry, your API key is invalid!")
              setApiKey("")
              setApiKeyIsValid(false)
            }
          }
        }
       } loggedIn={apiKeyIsValid}/>
       
       
      <div className="content">
      { openApiSpec ? <SwaggerUI spec={openApiSpec} onComplete={ // Note: passed url="" cuts down on browser errors, poor impl of Swagger UI React. 
        (x: any) => {
          // Grab this reference and hold onto it so we can preauthorize the API 
          swaggerUiRef = x
          if(apiKeyIsValid) {
            swaggerUiRef.preauthorizeApiKey("api_key", `ApiKey ${apiKey}`);
          }
      }}/> : "Sorry, no spec!"}
      
      </div>
    </div>

  );
}

// In order to authorize the open API spec, we need to do some magic with the SwaggerUI stuff. 
// Note: If you submitted a correct API key then updated with a bad one, the spec will continue 
// to use the old API key. This is technically incorrect but the fix is unclear and the cost
// of incorrectness seems low.
let swaggerUiRef: any